export { default } from '@dms/screen/care/live'
